import BybVrCard from "@Components/common/byb-ds/cards/byb-vr-card";
import ProgressMetricCard from "@Components/game/progress/progress-metric-card";
import { useProgress } from "@Context/game/progress/progress-context";
import MetricEventTypes from "@Enums/MetricEventTypes";
import useI18n from "@i18n";
import { Grid, Skeleton, Stack, Typography } from "@mui/material";

interface IMetricProgressSection {}

const MetricProgressSection = ({}: IMetricProgressSection) => {
  const { longTermMetricResults, isLongTermResultsLoading } = useProgress();
  const { i18n } = useI18n();

  const hasMetricResults = longTermMetricResults && Object.keys(longTermMetricResults).length > 0;

  return (
    <Stack gap={2}>
      <Typography variant="textLg700" color="text.primary">
        {i18n("progress.section.metric-progress")}
      </Typography>
      <Grid container spacing={2}>
        {hasMetricResults
          ? Object.keys(longTermMetricResults).map((metricKey, index) => {
              const metricScores = longTermMetricResults[metricKey as MetricEventTypes];

              return (
                <Grid item xs={12 / 5} key={index} sx={{ display: "flex" }}>
                  <ProgressMetricCard
                    metricKey={metricKey}
                    metricScores={metricScores}
                    isLoading={isLongTermResultsLoading}
                  />
                </Grid>
              );
            })
          : Array.from({ length: 5 }, (_, index) => (
              <Grid item xs={12 / 5} key={index} sx={{ display: "flex" }}>
                <BybVrCard>
                  <Stack spacing={2} width="100%">
                    <Skeleton variant="text" width="60%" height={40} animation="wave" />
                    <Stack direction="row" justifyContent="space-between" alignItems="baseline">
                      <Skeleton variant="text" width="50%" height={50} animation="wave" />
                      <Skeleton variant="text" width="20%" height={50} animation="wave" />
                    </Stack>
                    <Skeleton variant="rounded" width="100%" height={90} animation="wave" />
                  </Stack>
                </BybVrCard>
              </Grid>
            ))}
      </Grid>
    </Stack>
  );
};

export default MetricProgressSection;
